import React from 'react';
import { SETTINGS } from 'modules/emergencies/constants';
import RegularText from 'modules/emergencies/components/ui/texts/RegularText';
import BodyColumn from 'modules/emergencies/components/ui/columns/bodyColumn';
import styled from 'styled-components';

const CustomRegularText = styled(RegularText)`
  font-size: 14px;
  text-align: center;
  color: var(--grey700);
`;

export const CarrierColumn = ({ ticket }) => {
  const carrier = ticket.quote?.operation_details?.carrier;

  return (
    <BodyColumn
      backgroundColor={'#FFFFFF'}
      width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.CARRIER}
    >
      <CustomRegularText>{carrier}</CustomRegularText>
    </BodyColumn>
  );
};
